import React, { Fragment, useContext } from 'react';

import PresentationContext from '../PresentationContext';
import Stats from './Stats';
import { mgdL, internalUnits } from '../utils/consts';
import './Dashboard.css';

function ngsp2ifcc(d) {
  if (isNaN(d)) {
    return '?';
  }
  return `${(((d * 100) - 2.152) / 0.09148).toFixed(0)} mmol/mol`;
}

function percentFormat(d) {
  if (isNaN(d)) {
    return '?';
  }
  return `${(d * 100).toFixed(1)}%`;
}

function GlucoseStats({ activeTime, days = [], lastDay, stats: glucoseStats, t }) {

  const { durationFormat, formatGlucoseValue, formatGlucose, formatDateString } = useContext(PresentationContext);
  
  return (
    <Stats key="stats" id="stats" className="glucose stats">
      <h2>{t('glucoseStatsRow.stats.heading')}</h2>
      <dl>
        <dt>
          <time dateTime={days[0]}>{formatDateString(days[0])}</time>
          {
            days.length > 1
            ? (
              <Fragment>
                <span>{t('common.rangeSeparator')}</span>
                <time dateTime={lastDay}>{formatDateString(lastDay)}</time>
              </Fragment>
            )
            : null
          }
        </dt>
        <dd>
          <time dateTime={`PD${days.length}`}>{t('glucoseStatsRow.stats.timeRange', {count: days.length})}</time>
        </dd>
        <dt>{t('glucoseStatsRow.stats.cgmActivity')}</dt>
        <dd title={activeTime.summary}>
          <data value={activeTime.calculated} >{activeTime.calculated}</data>
        </dd>
      </dl>
      <table>
        <caption>{t('glucoseStatsRow.stats.ranges.description', {targetGlucoseRange: `${formatGlucoseValue({value: 70, unit: mgdL})}-${formatGlucose({value: 180, unit: mgdL})}`})}</caption>
        <thead>
          <tr>
            <th><span>{t('glucoseStatsRow.stats.ranges.heading')}</span></th>
        <th>{t('glucoseStatsRow.stats.targets.heading')} <small>{t('glucoseStatsRow.stats.targets.headingSmall')}</small></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th><span>{t('glucoseStatsRow.stats.ranges.target', {targetGlucoseRange: `${formatGlucoseValue({value: 70, unit: mgdL})}-${formatGlucose({value: 180, unit: mgdL})}`})}</span></th>
            <td><span>{t('glucoseStatsRow.stats.targets.target')} (<time dateTime="PT16H48M">{durationFormat((16 * 60) + 48)}</time>)</span></td>
          </tr>
          <tr>
            <th><span>{t('glucoseStatsRow.stats.ranges.low', {lowGlucoseMax: formatGlucose({value: 70, unit: mgdL})})}</span></th>
            <td><span>{t('glucoseStatsRow.stats.targets.low')} (<time dateTime="PT58M">{durationFormat(58)}</time>)</span></td>
          </tr>
          <tr>
            <th><span>{t('glucoseStatsRow.stats.ranges.hypo', {hypoGlucoseMax: formatGlucose({value: 54, unit: mgdL})})}</span></th>
            <td><span>{t('glucoseStatsRow.stats.targets.hypo')} (<time dateTime="PT14M">{durationFormat(14)}</time>)</span></td>
          </tr>
          <tr>
            <th><span>{t('glucoseStatsRow.stats.ranges.hyper', {hyperGlucoseMin: formatGlucose({value: 250, unit: mgdL})})}</span></th>
            <td><span>{t('glucoseStatsRow.stats.targets.hyper')} (<time dateTime="PT1H12M">{durationFormat(60 + 12)}</time>)</span></td>
          </tr>
        </tbody>
      </table>
      <dl>
        <dt>{t('glucoseStatsRow.stats.summary.glucoseAverage')}</dt>
        <dd>
          <data value={glucoseStats.mean}>{formatGlucose({ value: glucoseStats.mean, units: internalUnits })}</data>
        </dd>
        <dt>{t('glucoseStatsRow.stats.summary.gmi')}</dt>
        <dd>
          <data value={isNaN(glucoseStats.gmi) ? '?' : glucoseStats.gmi} title={ngsp2ifcc(glucoseStats.gmi)}>{percentFormat(glucoseStats.gmi)}</data>
        </dd>
        <dt>
          <details open={true}>
            <summary>{t('glucoseStatsRow.stats.summary.glucoseVariability')}</summary>
            <small>{t('glucoseStatsRow.stats.summary.glucoseVariabilityDescription')}</small>
          </details>
        </dt>
        <dd>
          <data value={isNaN(glucoseStats.cv) ? '?' : glucoseStats.cv}>{percentFormat(glucoseStats.cv)}</data>
        </dd>
      </dl>
    </Stats>
  );
}

export default GlucoseStats;
